import { GameView } from "./gameView.js";
const crownSrc = new URL("../../imgs/crown-svgrepo-com.svg", import.meta.url).href;
const globeSrc = new URL("../../imgs/globe-svgrepo-com.svg", import.meta.url).href;
const userSrc = new URL("../../imgs/user-plus-alt-1-svgrepo-com.svg", import.meta.url).href;
const closeSrc = new URL("../../imgs/xmark-svgrepo-com.svg", import.meta.url).href;

class LibraryView extends GameView {
  _parentElement = document.querySelector(".library__container");
  _parentBackground = document.querySelector(".library__container--background");
  _mainContainer = document.querySelector(".start__container");
  _page = 1;

  addHandlerLibrary(handler) {
    this._mainContainer.addEventListener(
      "click",
      function (e) {
        const btn = e.target.closest(`.start__library`);
        if (!btn) return;

        this._parentElement.classList.remove("hidden");
        this._parentBackground.classList.remove("hidden");

        handler();
      }.bind(this),
    );
  }

  renderClose() {
    const markup = ` <img class="library__close" src="${closeSrc}"> `;
    this._parentBackground.insertAdjacentHTML("afterbegin", markup);
  }

  addHandlerCloseKeydown() {
    this._mainContainer.addEventListener(
      "keydown",
      function (e) {
        if (e.key !== "Escape") return;
        if (this._parentElement.classList.contains("hidden")) return;
        this._parentElement.classList.add("hidden");
        this._parentBackground.classList.add("hidden");
      }.bind(this),
    );
  }

  addHandlerCloseClick() {
    document.addEventListener(
      "click",
      function (e) {
        const btn = e.target.closest(`.library__close`);
        if (btn || e.target === this._parentBackground) {
          this._parentElement.classList.add("hidden");
          this._parentBackground.classList.add("hidden");
        }
      }.bind(this),
    );
  }

  _generateMarkup() {
    const markup = this._data
      .map(
        (data) => `
        
        <div class="library__container--inner">
          <div class="library__container--details">

            <img class="library__flag" src="${data.image}"/>
            <div class="library__name">${data.name}</div> 

            <div class="library__info">

              <div class="library__capital library__info--details">
                <img class="library__icons" src="${crownSrc}" alt="Image of a crown representing the capital of a country"/>
                ${data.capital}
              </div> 

              <div class="library__continent library__info--details">
                <img class="library__icons" src="${globeSrc}" alt="Image of a globe representing the continent of a country"/>
                ${data.continent}
              </div> 

              <div class="library__population library__info--details">
                <img class="library__icons" src="${userSrc}" alt="Image of a person representing the population of a country"/>
                ${data.population.toLocaleString("en-US")} 
              </div>

            </div>
              
          </div>
        </div>

     `,
      )
      .join("");
    return markup;
  }
}

export default new LibraryView();
